export const LOCAL_STORAGE_KEYS = {
  TASK_FILTERS: 'taskFilters',
  MEMORY_FILTERS: 'memoryFilters',
  DOCK_POSITION: 'dockPosition',
  DOCK_COORDINATES: 'dockCoordinates',
  DOCK_VISIBLE: 'dockVisible',
  DASHBOARD_TOUR_COMPLETED: 'dashboardTourCompleted',
  SENT_PROMPTS_FILTERS: 'sentPromptsFilters',
} as const;
